import React from 'react';
import {
  CalendarPlus, Gift, UserCheck, X, Eye,
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { Textarea } from '../../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const UserActivityModal = ({ ctx }) => {
  const { showActivityModal, setShowActivityModal, userActivity } = ctx;
  return (
          <Dialog open={showActivityModal} onOpenChange={setShowActivityModal}>
            <DialogContent className="sm:max-w-lg max-h-[80vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Gebruiker Activiteit</DialogTitle>
                <DialogDescription>
                  {userActivity?.user?.name} ({userActivity?.user?.email})
                </DialogDescription>
              </DialogHeader>
              
              {userActivity && (
                <div className="space-y-4 py-4">
                  {/* Stats */}
                  <div className="grid grid-cols-3 gap-3 text-center">
                    <div className="p-3 rounded-lg bg-muted/50">
                      <p className="text-2xl font-bold">{userActivity.stats?.total_stories || 0}</p>
                      <p className="text-xs text-muted-foreground">Verhalen</p>
                    </div>
                    <div className="p-3 rounded-lg bg-muted/50">
                      <p className="text-2xl font-bold text-green-600">{userActivity.stats?.approved_stories || 0}</p>
                      <p className="text-xs text-muted-foreground">Goedgekeurd</p>
                    </div>
                    <div className="p-3 rounded-lg bg-muted/50">
                      <p className="text-2xl font-bold text-gold">{userActivity.stats?.total_reads || 0}</p>
                      <p className="text-xs text-muted-foreground">Gelezen</p>
                    </div>
                  </div>

                  {/* User Info */}
                  <div className="space-y-2">
                    <h4 className="font-medium text-sm">Account Info</h4>
                    <div className="p-3 rounded-lg bg-muted/30 text-sm space-y-1">
                      <p>Aangemaakt: {userActivity.user?.created_at ? new Date(userActivity.user.created_at).toLocaleDateString('nl-NL') : 'Onbekend'}</p>
                      <p>Admin: {userActivity.user?.is_admin ? 'Ja' : 'Nee'}</p>
                      <p>Geblokkeerd: {userActivity.user?.is_blocked ? 'Ja' : 'Nee'}</p>
                    </div>
                  </div>

                  {/* Subscription */}
                  {userActivity.subscription && (
                    <div className="space-y-2">
                      <h4 className="font-medium text-sm">Abonnement</h4>
                      <div className="p-3 rounded-lg bg-muted/30 text-sm space-y-1">
                        <p>Status: {userActivity.subscription.status}</p>
                        <p>Plan: {userActivity.subscription.plan}</p>
                        {userActivity.subscription.subscription_end_date && (
                          <p>Eindigt: {new Date(userActivity.subscription.subscription_end_date).toLocaleDateString('nl-NL')}</p>
                        )}
                        {userActivity.subscription.affiliate_code && (
                          <p>Affiliate code: {userActivity.subscription.affiliate_code}</p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Grandma Profile */}
                  {userActivity.grandma && (
                    <div className="space-y-2">
                      <h4 className="font-medium text-sm">Oma Profiel</h4>
                      <div className="p-3 rounded-lg bg-muted/30 text-sm">
                        <p className="font-medium">{userActivity.grandma.name}</p>
                        <p className="text-muted-foreground">{userActivity.grandma.bio}</p>
                      </div>
                    </div>
                  )}

                  {/* Stories */}
                  {userActivity.stories?.length > 0 && (
                    <div className="space-y-2">
                      <h4 className="font-medium text-sm">Verhalen ({userActivity.stories.length})</h4>
                      <div className="space-y-2">
                        {userActivity.stories.map(story => (
                          <div key={story.id} className="p-3 rounded-lg bg-muted/30 flex justify-between items-center">
                            <div>
                              <p className="font-medium text-sm">{story.title}</p>
                              <p className="text-xs text-muted-foreground">
                                {story.is_approved ? '✓ Goedgekeurd' : '⏳ Wachtend'}
                              </p>
                            </div>
                            <div className="flex items-center gap-1 text-xs text-muted-foreground">
                              <Eye className="w-3 h-3" />
                              {story.read_count || 0}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              <DialogFooter>
                <Button variant="outline" onClick={() => setShowActivityModal(false)}>
                  Sluiten
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
  );
};
